<template>
  <div class="lesson-videos row">
    <div v-for="(video, index) in videos" class="col-lg-6 py-2" :key="index">
      <video-player :lesson="video" :id="`video-player-${index}`" />
    </div>
  </div>
</template>

<script>
import VideoPlayer from "@/components/lesson/VideoPlayer";

export default {
  components: { VideoPlayer },
  props: {
    videos: {
      type: Array,
      default: () => []
    }
  }
};
</script>
